import type { FormInstance } from '@arco-design/web-react/es/Form';

import { SKU_RESOURCE_MODULES_FIELD, type SkuResourceModulesState } from '../types';

/** 镜像/联动预置写入模块数据后，将对应 skuResourceModules 勾选项置为 true（不取消已有勾选） */
export function enableSkuModulesForPreset(form: FormInstance, moduleKeys: readonly string[]): void {
  if (!moduleKeys.length) return;
  const current = form.getFieldValue?.(SKU_RESOURCE_MODULES_FIELD) as SkuResourceModulesState | undefined;
  const next = current && typeof current === 'object' ? { ...current } : {};
  let changed = false;
  for (const key of moduleKeys) {
    if (next[key] !== true) {
      next[key] = true;
      changed = true;
    }
  }
  if (changed) {
    form.setFieldValue(SKU_RESOURCE_MODULES_FIELD, next);
  }
}
